import React, { Component } from "react";

export default function asyncComponent(importComponent) {
	class AsyncComponent extends Component<any, any> {
		_isMounted = false;

		constructor(props) {
			super(props);
			this.state = {
				component: null,
			};
		}

		componentDidMount() {
			this._isMounted = true;

			importComponent()
				.then(comp => {
					if (this._isMounted) {
						this.setState({
							component: comp.default,
						});
					}
				})
				.catch(() => {
					/* ignored */
				});
		}

		componentWillUnmount() {
			this._isMounted = false;
		}

		render() {
			const Comp = this.state.component;
			return Comp ? <Comp {...this.props} /> : null;
		}
	}

	return AsyncComponent;
}
